import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import moment from 'moment-timezone';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor() { }

  getDataDiff(startDate: any, endDate: any) {
    startDate = new Date(startDate);
    endDate = new Date(endDate);

    // Convert the Date object to a moment object
    let diff = endDate.getTime() - startDate.getTime();
    let years = Math.floor(diff / (365.25 * 24 * 60 * 60 * 1000))
    let months = Math.floor(diff / (30.44 * 24 * 60 * 60 * 1000));
    let days = Math.floor(diff / (60 * 60 * 24 * 1000));
    let hours = Math.floor(diff / (60 * 60 * 1000)) - (days * 24);
    let minutes = Math.floor(diff / (60 * 1000)) - ((days * 24 * 60) + (hours * 60));
    let seconds = Math.floor(diff / 1000) - ((days * 24 * 60 * 60) + (hours * 60 * 60) + (minutes * 60));

    if (years > 0) {
      return years + " years ago"
    }

    if (months > 0) {
      return months + " months ago"
    }

    if (days > 0) {
      return days + " days ago"
    }

    if (hours > 0) {
      return hours + " hours ago"
    }

    if (minutes > 0) {
      return minutes + " minutes ago";
    }

    if (seconds) {
      return seconds + " seconds ago"
    }

    return new DatePipe('en-US','Asia/Riyadh').transform(startDate);
  }
}
